import { getTextFromForgeDocChildren } from '../../../utils/getTextFromForgeDocChildren';
export var componentPropsConfig = {
  appearance: true,
  children: {
    value: 'getTextFromForgeDocChildren(props.forgeDoc)',
    comment: 'Lozenge should only accept plain text as children'
  },
  isBold: true,
  maxWidth: true,
  testId: true
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::3a4a9996da27b0d5b98f255cd179e2c9>>
 * @codegenId #lozenge
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen lozenge
 * @codegenDependency ../../../../../../../design-system/lozenge/src/Lozenge/index.tsx <<SignedSource::db7d8f2c107db670b4f88cb8fb3f3ce3>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import PlatformLozenge from '@atlaskit/lozenge';
/**
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 */
export var Lozenge = function Lozenge(props) {
  var _ref = props.forgeDoc.props,
    appearance = _ref.appearance,
    isBold = _ref.isBold,
    maxWidth = _ref.maxWidth,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(PlatformLozenge, {
    appearance: appearance
    // Lozenge should only accept plain text as children
    ,
    children: getTextFromForgeDocChildren(props.forgeDoc),
    isBold: isBold,
    maxWidth: maxWidth,
    testId: testId
  });
};
/**
 * @codegenEnd
 */